// import partner01 from "../assets/images/logo-parceiro01.jpg";
// import partner02 from "../assets/images/logo-parceiro02.jpg";
// import partner03 from "../assets/images/logo-parceiro03.jpg";
// import partner04 from "../assets/images/logo-parceiro04.jpg";
// import partner05 from "../assets/images/logo-parceiro05.jpg";
import partner01 from "../assets/images/logo-ibda.png";
import partner02 from "../assets/images/logo-capes.png";
import partner03 from "../assets/images/logo-faperj.png";
import partner04 from "../assets/images/logo-cnpq.png";
import partner05 from "../assets/images/logo-proprietas.png";

const mock = [{
  name: "test",
  thumb: partner01,
}, {
  name: "test",
  thumb: partner02,
}, {
  name: "test",
  thumb: partner03,
}, {
  name: "test",
  thumb: partner04,
}, {
  name: "test",
  thumb: partner05,
},];

export default mock;